// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3nmqg","bigColWidth":"Table_bigColWidth__Ivn5T","biggerColWidth":"Table_biggerColWidth__1ppwf","row":"Table_row__1F4zV","col":"Table_col__3DxiE"};